import axios from 'axios';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import api from '../../../api/Api';

function AllEmployees() {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [totalPages, setTotalPages] = useState(0);
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setpageSize] = useState(8);
  const [page, setPage] = useState(0)
  const navigate = useNavigate();

  const fetchEmployees = (page) => {
    api
      .post("/api/employees/all", {
        search: search && search.trim() !== "" ? search : null
      }, {
        params: { page, size: pageSize, sort: `${sortField},${sortOrder}` },
      })
      .then((response) => {
        const data = response.data.response;
        setEmployees(data.content);
        setTotalPages(data.totalPages);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchEmployees(page);
  }, [page, sortField, sortOrder]);


   useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setPage(0); 
      fetchEmployees(0);
    }, 300); 
    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleClick = (identy) => {
    navigate(`/employees/${identy}`);
  };


  const handlePageChange = (event, value) => {
    setPage(value - 1);
    fetchEmployees(value - 1);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortOrder('asc');
    }
  };

  return (
    <div className="container-fluid"
      style={{
        height: "100%",
        borderRadius: "20px",
        overflow: 'hidden'
      }}>

      {/* Top Controls */}
      <div className="d-flex justify-content-between align-items-center flex-wrap p-3">
        <h2 className="ms-1 mb-3">All Employees</h2>
        <input
          className="form-control rounded-pill p-3 mb-3"
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name or designation..."
          style={{ width: '60%', fontSize: '15px' }} />
        <Link to="/employees/add" className="btn btn-primary mb-3">
          + Add Employee
        </Link>
      </div>

      {/* Table Container */}
      <div style={{ flex: 1 }} className="px-3">
        <table className="table table-bordered table-hover shadow-sm">
          <thead className="table-primary">
            <tr>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('name')}>
                Name {sortField === 'name' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('employeeId')}>
                Employee ID {sortField === 'employeeId' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('email')}>
                Email {sortField === 'email' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('designation')}>
                Designation {sortField === 'designation' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
              <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('location')}>
                Office Location {sortField === 'location' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
               <th
                style={{ position: 'sticky', top: 0, background: '#0D59A7',color : 'white', zIndex: 1, cursor: 'pointer' }}
                onClick={() => handleSort('shift')}>
                Shift {sortField === 'shift' ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
              </th>
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((e) => (
                <tr key={e.identy}
                  onClick={() => handleClick(e.identy)}
                  style={{ cursor: 'pointer' }}>
                  <td className="text-capitalize">{e.name}</td>
                  <td>{e.employeeId}</td>
                  <td>{e.email}</td>
                  <td>{e.designation}</td>
                  <td>{e.location}</td>
                  <td>{e.shift}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted">No matching employees found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>


      <div className="d-flex justify-content-center mt-3">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>
    </div>


  );
}

export default AllEmployees;
